export const teams = state => state.teams.items
export const teamById = state => id => _.find(state.teams.items, {id: parseInt(id)})
export const teamNameById = (state, getters) => id => {
    let team = getters.teamById(id)
    return team ? team.name : ''
}